export default "__VITE_ASSET__iJaUBmCa__"